import { IScrollObserverService } from '../interfaces/scroll-observer-service.interface';
import { ScrollAwareComponent } from './scroll-aware.component';

export class ScrollClassTogglerComponent extends ScrollAwareComponent {
    protected scrollObserverService: IScrollObserverService;

    protected get class(): string {
        return this.element.dataset.class;
    }

    constructor(protected element: HTMLElement) {
        super(element);
    }

    protected onTargetScrollInOut(isWithinViewport: boolean): void {
        for (const target of this.targets) {
            if (this.scrollObserverService.isElementVisibleInViewPort(target)) {
                this.element.classList.remove(this.class);

                return;
            }
        }

        this.element.classList.add(this.class);
    }
}
